import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesSection.css';

const ServicesSection: React.FC = () => {
  return (
    <section id="services" className="services-section">
      <div className="services-background" />
      
      <div className="container">
        <div className="services-container">
          
          {/* Section Header */}
          <div className="services-header">
            <div className="services-badge">
              <div className="services-badge-dot" />
              What We Offer
            </div>
            
            <h2 className="services-title">Comprehensive Cybersecurity Solutions</h2>
            
            <p className="services-subtitle">
              Advanced AI-powered security services designed to protect your digital infrastructure from evolving cyber threats
            </p>
          </div>
          
          {/* Services Grid */}
          <div className="services-grid">
            
            {/* Real-time Monitoring */}
            <div className="service-card service-card-featured">
              <div className="service-card-icon">
                <i className="ri-radar-line"></i>
              </div>
              <h3 className="service-card-title">Real-time Threat Monitoring</h3>
              <p className="service-card-description">
                24/7 continuous monitoring of your network infrastructure with instant threat detection and response capabilities.
              </p>
              <div className="service-card-features">
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Live network scanning</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Instant threat alerts</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Automated response</span>
                </div>
              </div>
            </div>
            
            {/* AI Analytics */}
            <div className="service-card">
              <div className="service-card-icon">
                <i className="ri-brain-line"></i>
              </div>
              <h3 className="service-card-title">AI-Powered Analytics</h3>
              <p className="service-card-description">
                Machine learning algorithms analyze patterns to predict and prevent security breaches before they occur.
              </p>
              <div className="service-card-features">
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Predictive threat analysis</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Behavior pattern recognition</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Risk assessment</span>
                </div>
              </div>
            </div>
            
            {/* Security Reports */}
            <div className="service-card">
              <div className="service-card-icon">
                <i className="ri-file-chart-line"></i>
              </div>
              <h3 className="service-card-title">Comprehensive Reports</h3>
              <p className="service-card-description">
                Detailed security reports with actionable insights and compliance documentation for your organization.
              </p>
              <div className="service-card-features">
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Detailed analytics</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Compliance tracking</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Executive summaries</span>
                </div>
              </div>
            </div>
            
            {/* Incident Response */}
            <div className="service-card">
              <div className="service-card-icon">
                <i className="ri-shield-flash-line"></i>
              </div>
              <h3 className="service-card-title">Incident Response</h3>
              <p className="service-card-description">
                Rapid incident response team with automated containment and forensic analysis capabilities.
              </p>
              <div className="service-card-features">
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Emergency response</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Forensic analysis</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Recovery planning</span>
                </div>
              </div>
            </div>
            
            {/* Vulnerability Assessment */}
            <div className="service-card">
              <div className="service-card-icon">
                <i className="ri-search-eye-line"></i>
              </div>
              <h3 className="service-card-title">Vulnerability Assessment</h3>
              <p className="service-card-description">
                Comprehensive security audits to identify and remediate vulnerabilities in your infrastructure.
              </p>
              <div className="service-card-features">
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Security audits</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Penetration testing</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Remediation guidance</span>
                </div>
              </div>
            </div>
            
            {/* Compliance Management */}
            <div className="service-card">
              <div className="service-card-icon">
                <i className="ri-award-line"></i>
              </div>
              <h3 className="service-card-title">Compliance Management</h3>
              <p className="service-card-description">
                Ensure adherence to industry standards and regulations with automated compliance monitoring.
              </p>
              <div className="service-card-features">
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>GDPR compliance</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>ISO 27001 standards</span>
                </div>
                <div className="service-feature">
                  <i className="ri-check-line"></i>
                  <span>Audit preparation</span>
                </div>
              </div>
            </div>
            
          </div>
          
          {/* Call to Action */}
          <div className="services-cta">
            <h3 className="services-cta-title">Ready to Secure Your Digital Assets?</h3>
            <p className="services-cta-description">
              Get started with our comprehensive cybersecurity platform and protect your organization from evolving threats.
            </p>
            <div className="services-cta-buttons">
              <Link to="/register" className="services-btn services-btn-primary">
                <span>Start Free Trial</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a href="#contact" className="services-btn services-btn-secondary">
                <span>Contact Us</span>
                <i className="ri-message-line"></i>
              </a>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
